import React from 'react';
import { Helmet } from 'react-helmet-async';
import './MapResources.css';
import SearchScreenNav from '../components/SearchScreenNav';

const MapResources = () => {
  return (
    <div className="resources-page-container">
      <Helmet>
        <title>Resource Map | LGBT PridePath</title>
        <meta name="description" content="Interactive map of LGBT+ resources across the United States. Search by ZIP code and filter by category to find community support near you." />
        <link rel="canonical" href="https://www.lgbtpridepath.org/map-resources" />
        <meta property="og:title" content="Resource Map | LGBT PridePath" />
        <meta property="og:description" content="Interactive map of LGBT+ resources. Search by ZIP code to find community support near you." />
        <meta property="og:url" content="https://www.lgbtpridepath.org/map-resources" />
        <meta property="og:type" content="website" />
      </Helmet>
      
      {/* Custom navigation for overlay effect */}
      <SearchScreenNav />
      

      {/* Interactive Map Section */}
      <section className="resources-map-section">
        <div className="resources-map-content">
          <div className="resources-map-header">
            <h2 className="resources-section-header">Interactive Resource Map</h2>
            <p className="resources-map-description">
              Search by ZIP code, filter by category, and explore LGBT+ resources across the United States. 
              Click on any location marker to view detailed information about services, hours, and contact details.
            </p>
          </div>
          
          <div className="resources-map-container">
            <iframe 
              src="http://localhost:3005/map?embedded=true&apiKey=demo&theme=purple"
              width="100%"
              height="800"
              frameBorder="0"
              loading="lazy"
              title="LGBT Resources Map"
              className="resources-map-iframe"
            ></iframe>
          </div>
        </div>
      </section>


      {/* Additional Help Section */}
      <section className="resources-help-section">
        <div className="resources-help-content">
          <h2 className="resources-section-header">Need Immediate Support?</h2>
          <p className="resources-help-text">
            If you need to talk to someone right now, our helplines are staffed by trained 
            LGBT-identified volunteers who are here to listen and support you.
          </p>
          <div className="resources-help-buttons">
            <a 
              href="https://lgbthotline.org/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="resources-help-button"
            >
              Call Our Hotline
            </a>
            <a 
              href="https://lgbthotline.org/chat" 
              target="_blank" 
              rel="noopener noreferrer"
              className="resources-help-button resources-help-button-secondary"
            >
              Start Online Chat
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default MapResources;